import React from "react";

import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function JobEditTabsHeaderSkeleton() {

  return (
    <div className="job-edit-header">
      <div className='row-modal' >
        <Stack spacing={1}>
          <Skeleton variant="rectangular" width={120} height={12} />
          <Skeleton variant="rectangular" width={120} height={12} />
          <Skeleton variant="rectangular" width={120} height={12} />
        </Stack>

        <Stack spacing={1}>
        <Skeleton variant="rectangular" width={120} height={12} />
        <Skeleton variant="rectangular" width={120} height={12} />
        <Skeleton variant="rectangular" width={120} height={12} />
        </Stack>
        
      </div>
      <div className="row-modal" style={{ alignItems: 'flex-end' }} >
        <div style={{ marginTop: '1em' }}>
          <Stack spacing={1}>
            <Skeleton variant="rectangular" width="100%" height={30} sx={{margin: '0 0 1em 0'}} />
            <div className='row-modal' style={{ margin: '0 0 1em 0', justifyContent: 'flex-start', alignItems:'center' }} >
              <Skeleton variant="circular" height="24px" width="24px" sx={{ marginRight: "8px" }} />
              <Skeleton variant="rectangular" width={150} height={32} />
            </div>
            <div className='row-modal' style={{ margin: '0 0 1em 0', justifyContent: 'flex-start', alignItems:'center' }}>
            <Skeleton variant="circular" height="24px" width="24px" sx={{ marginRight: "8px" }} />
              <Skeleton variant="rectangular" width={175} height={32} />
            </div>
          </Stack>
        </div>
        <div className="column-modal" style={{ margin: '0' }} >
        <Stack spacing={2}>
        <Skeleton variant="rectangular" width={190} height={36} sx={{borderRadius:'2em'}} />
        <Skeleton variant="rectangular" width={190} height={36} sx={{borderRadius:'2em'}} />
        </Stack>
        </div>
      </div>
    </div>
  );
}
